import { Box, Paper, Typography } from "@mui/material"
import moment from "moment"

function Slot({ data, day }) {

  return (!!data?.schedule?.[day] &&
    <Paper variant="contentListing" sx={{ p: 2, display: "flex", alignItems: "center", flexWrap: "nowrap", gap: 1 }}>
      <Typography
        sx={{
          flexGrow: "1",
          flexBasis: "0",
          fontWeight: "500",
          textTransform: "capitalize"
        }}
      >{day}: </Typography>
      <Box sx={{ flexGrow: "1" }}>
        <Typography component="span">{
          moment
            .tz(
              data?.schedule?.[day]?.startTime,
              "HH:mm",
              data?.timeZone
            )
            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .format("hh:mm A")
        }</Typography> to <Typography component="span">{
          moment
            .tz(
              data?.schedule?.[day]?.endTime,
              "HH:mm",
              data?.timeZone
            )
            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .format("hh:mm A")
        }</Typography>
      </Box>
    </Paper>
  )
}

export default Slot